import * as React from 'react'

interface PropTypes {
  tabs: string[]
}

export default function index(props: PropTypes) {
  // const {tabs} = props;
  // const tabString = tabs.toString().toLocaleLowerCase();
  // // 无交易评价不展示数据
  // if (tabString.indexOf('discuss') === -1 && tabString.indexOf('transactions') === -1) {
  //   return null;
  // }
  return (
    <div id='product-review'></div>
  )
}
